export default "__VITE_ASSET__D3Oqy0Z1__"